import { useContext } from 'react';
import { ApplicationContext, ApplicationConfigData } from '../contexts/ApplicationConfig';

export default function useApplicationConfig(): ApplicationConfigData {
  const context = useContext(ApplicationContext);
  return context;
}
